import { render, staticRenderFns } from "./workFlowLabelGroup.vue?vue&type=template&id=7ba0342d&scoped=true&"
import script from "./workFlowLabelGroup.vue?vue&type=script&lang=js&"
export * from "./workFlowLabelGroup.vue?vue&type=script&lang=js&"
import style0 from "./workFlowLabelGroup.vue?vue&type=style&index=0&id=7ba0342d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba0342d",
  null
  
)

export default component.exports